export function nextTick (callback) {
    let mactoTimerFunc = function(){
        if (callback && typeof callback === 'function') {
            callback();
        }
    };
    if (typeof Promise !== undefined) {
        mactoTimerFunc = function() {
            new Promise(function(resolve, reject){
                resolve();
            }).then(function(){
                if (callback && typeof callback === 'function') {
                    callback();
                }
            })
        }
    } else if (typeof MessageChannel !== undefined && MessageChannel.toString() === 'function MessageChannel() { [native code] }') {
        const channel = new MessageChannel();
        const port = channel.port2;
        channel.port1.onmessage = function() {
            if (callback && typeof callback === 'function') {
                callback();
            }
        }
        mactoTimerFunc = function() {
            port.postMessage(1);
        }
    } else {
        mactoTimerFunc = function () {
            setTimeout(function(){
                if (callback && typeof callback === 'function') {
                    callback();
                }
            }, 0);
        }
    }
    return mactoTimerFunc;
}